import PropTypes from 'prop-types';
import { PrimaryButton } from 'jl-design-system/elements/button/Button';

import styles from './ScreenNav.scss';

export const NextButton = ({ text = 'Next', ...props }) => (
  <PrimaryButton inline className={styles.NavButton} {...props}>
    {text}
  </PrimaryButton>
);

NextButton.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
};
